// src/features/developer/components/DeveloperDashboard.tsx
import React, { useState } from 'react'
import Tabs from '../../../../shared/components/ui/Tabs'
import SimulatorPanel from '../components/SimulatorPanel'
import LoggerPanel from '../components/LoggerPanel'
import Testing from './Testing'

export default function DeveloperDashboard() {
  const subTabLabels = ['Simulator', 'Logger', 'Testing']
  const [activeSubTab, setActiveSubTab] = useState<string>('Simulator')

  return (
    <section className="space-y-6">
      <h1 className="text-xl font-semibold text-neutral-100">Developer</h1>
      <Tabs
        tabs={subTabLabels}
        activeTab={activeSubTab}
        onTabChange={setActiveSubTab}
      />

      <div className="mt-4">
        {activeSubTab === 'Simulator' && <SimulatorPanel />}
        {activeSubTab === 'Logger' && <LoggerPanel />}
        {activeSubTab === 'Testing' && <Testing />}
      </div>
    </section>
  )
}
